if (typeof Plugin_Smlouva === 'undefined') {

    var Plugin_Smlouva = {

        init: function () {
            $('button#button-create-contract-document')
                .off('click')
                .on('click', function(e) {
                e.preventDefault();
                var dotacniTitulId = $('#dotacnititul').val();

                $.ajax({
                    type: 'get',
                    url: '/plugin/PluginSmlouva/ajaxCheckTemplates?dt=' + dotacniTitulId,
                    dataType: "json",
                    success: function(response) {

                        if (response.hasOwnProperty('messages')) {
                            Lemo_Alert.addMany(response.messages);
                        }

                        if (true === response.status) {
                            if (1 === response.data.count) {
                                Plugin_Smlouva.generate(dotacniTitulId, $('#idItem').val(), response.data.template);
                            }
                            if (response.data.count > 1 && null !== response.html) {
                                Lemo_Modal.setTitle(translate('Contract template'));
                                Lemo_Modal.setContent(response.html);
                                Lemo_Modal.addButton('generate', translate('Generate'), 'btn btn-primary', function() {
                                    Plugin_Smlouva.generate(dotacniTitulId, $('#idItem').val(), $('#formTemplate').find('#template').val());
                                    Lemo_Modal.close();
                                });
                                Lemo_Modal.addButton('cancel', 'Cancel', 'btn btn-default', function() {
                                    Lemo_Modal.close();
                                });
                                Lemo_Modal.build();
                            }
                        } else {
                            Lemo_Alert.addDanger('No template file found', 'noTemplateFound');
                        }
                    }
                });
            });
        },

        generate: function(dotacniTitulId, zadostId, sablonaId)
        {
            window.location = '/plugin/PluginSmlouva/generate?dtId=' + dotacniTitulId + '&zaId=' + zadostId + '&saId=' + sablonaId;
        }
    }
}

$(document).ready(function () {
    Plugin_Smlouva.init();
});

